<template>
  <div class="check-evaluate">
    <div v-if="history === 'WAITING_COMMENT'" class="check-around">
      <div v-for="(item,index) of historyList" :key="index" class="product-around">
        <div v-if="item.type === 'SCORE'">
          <div class="product-around-title">
            <p>{{ index + 1 + '.' }}</p>
            <p>{{ item.title }}</p>
          </div>
          <div class="serach-around-select">
            <van-field
              :placeholder="$t('score')"
              :value="item.answer"
              class="van-cell-state"
              clickable
              readonly
              @click="handleSelectIndexClick(index)"
            />
            <img class="cell-state-img" src="@/assets/images/icon_down@2x.png">
          </div>
        </div>
        <van-popup v-model="showPicker" position="bottom" round>
          <van-picker
            :columns="selevtList"
            show-toolbar
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
        <div v-if="item.type === 'SHORT_ANSWER'" class="short-problem">
          <div class="check-problem">
            <p class="check-problem-sign">*{{ $t('notScored') }}</p>
            <div class="check-problem-title">
              <p>{{ index + 1 + '.' }}</p>
              <p>*</p>
              <p>{{ item.title }}</p>
            </div>
          </div>
          <textarea
            v-model="item.answer"
            :placeholder="$t('suggestions')"
            class="check-problem-textarea"
            placeholder-style="color: #808C9B"
          />
        </div>
      </div>
      <button class="check-problem-button" @click="handleSumbitQuestion">{{ $t('submit') }}</button>
    </div>
    <div v-else class="check-around">
      <div v-for="(item,index) of historyList" :key="index" class="product-around">
        <div v-if="item.appraisal.type === 'SCORE'">
          <div class="product-around-title">
            <p>{{ index + 1 + '.' }}</p>
            <p>{{ item.appraisal.title }}</p>
          </div>
          <div class="serach-around-history">
            {{ item.score }}
          </div>
        </div>
        <van-popup v-model="showPicker" position="bottom" round>
          <van-picker
            :columns="selevtList"
            show-toolbar
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
        <div v-if="item.appraisal.type === 'SHORT_ANSWER'" class="short-problem">
          <div class="check-problem">
            <p class="check-problem-sign">*{{ $t('notScored') }}</p>
            <div class="check-problem-title">
              <p>*</p>
              <p>{{ item.appraisal.title }}</p>
            </div>
          </div>
          <textarea
            v-model="item.shortAnswer "
            disabled
            :placeholder="$t('suggestions')"
            class="check-problem-textarea"
            placeholder-style="color: #808C9B"
          />
        </div>
      </div>
      <button v-if="!history" class="check-problem-button" @click="handleSumbitQuestion">{{ $t('submit') }}</button>
    </div>
  </div>
</template>

<script>
import { NUMBER } from '@/api/constants'
import { Toast } from 'vant'
import { removeLocalStore } from '../../utils'

export default {
  name: 'CheckEvaluate',
  data() {
    return {
      history: '', // 评价状态
      historyList: [], // 历史问卷列表
      RepairId: '', // 整单id
      SumbitProblemList: [], // 提交列表
      ProductsList: [], // 问答列表
      SoreProductsList: [], // 问答列表
      showPicker: false, // 评分选择器
      selecrIndex: [] // 分数
    }
  },
  computed: {
    // 评分内容
    selevtList() {
      return NUMBER
    }
  },
  mounted() {
    this.RepairId = Number(this.$route.query.id)
    this.$api('REPAIR_INFO_H5', {
      UserRepairId: this.RepairId
    }).then((res) => {
      if (res.code !== 200) {
        Toast(res.msg)
        return
      }
      removeLocalStore('redirect')
      this.history = res.result.repairStatus
      if (this.history === 'WAITING_COMMENT') {
        this.handleGetEvaluate()
        return
      }
      this.hadnleGetHisstory()
    })
  },
  methods: {
    /*
      获取评价列表
    */
    handleGetEvaluate() {
      this.$api('APPRAISAL_LIST_H5', {}, true).then((res) => {
        this.historyList = res.result.map(x => {
          return {
            ...x,
            answer: ''
          }
        })
      })
    },
    /*
    提交问卷
   */
    handleSumbitQuestion() {
      const appraisalRecordInfoList = this.historyList.map(x => {
        return {
          appraisalId: x.id,
          [x.type]: x.answer
        }
      })
      const appraisalBlean = appraisalRecordInfoList.some(item => {
        return item.SCORE === '' || item.SHORT_ANSWER === ''
      })
      if (appraisalBlean === true) {
        this.$toast.fail('内容不能为空')
        return
      }
      this.$api('APPRAISAL_RECORD_SUBMIT_H5', {
        userRepairId: this.RepairId,
        appraisalRecordInfoList
      }, true).then((res) => {
        if (res.code !== 200) {
          this.$toast(res.msg)
        } else {
          this.$toast('评价成功')
          this.$router.push('/')
        }
      })
    },
    /*
      打开评分选择器
     */
    handleSelectIndexClick(index) {
      this.index = index
      this.showPicker = true
    },
    /*
    查看历史问卷
   */
    hadnleGetHisstory() {
      this.$api('APPRAISAL_RECORD_LIST_H5', {
        userRepairId: this.RepairId
      }, true).then(res => {
        this.historyList = res.result
      })
    },
    /*
      评分选择器
     */
    onConfirm(value) {
      this.historyList[this.index].answer = value
      this.showPicker = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-overlay {
  background-color: rgba(0,0,0,0.2);
}
.check-evaluate {
  padding: 15px 15px;

  .check-around {
    padding: 14.5px 15px;
    background-color: #ffffff;
    border-radius: 5px;

    .short-problem {

    }

    .serach-around-select {
      margin-top: 14px;
      display: flex;
      align-items: center;
      margin-right: 10px;
      border: solid 0.5px #000000;
      padding: 0px 5px;
      height: 25px;
      width: 172.5px;

      .van-cell-state {
        height: 20px;
        align-items: center;
      }

      .cell-state-img {
        width: 10px;
        height: 10px;
      }
    }
    .serach-around-history {
      font-size: 15px;
      margin-left: 15px;
      margin-top: 10px;
    }
    .product-around {
      margin-bottom: 23.5px;

      &-title {
        display: flex;
        font-size: 14px;
        color: #000000;
        line-height: 21px;

        p:last-child {
          margin-left: 7px;
        }
      }

      .check-select {
        color: #808C9B;
        width: 172.5px;
        height: 25px;
        margin: 14px 0 0 16px;
        padding: 0 10px;
        border: 1px solid rgba(242, 242, 242, 1);
      }
    }

    .check-problem {
      margin-left: 10px;
      margin-top: 32.5px;
      display: flex;
      flex-direction: column;

      .check-problem-sign {
        font-size: 12px;
        color: #808C9B;
      }

      .check-problem-title {
        display: flex;
        font-size: 14px;
        color: #005BAC;
        margin-top: 15px;
        line-height: 21px;
        font-weight: 500;
      }

    }

    .check-problem-textarea {
      border: 1px solid #F2F2F2;
      width: 280px;
      font-size: 12px;
      padding: 12px;
      height: 84px;
      border-radius: 5px;
      margin-top: 15.5px;
    }

    .check-problem-button {
      border: none;
      width: 300px;
      height: 44px;
      text-align: center;
      margin: 0 auto;
      border-radius: 22px;
      background-color: #005BAC;
      color: #ffffff;
      margin-top: 30px;
      font-size: 15px;
    }
  }
}
</style>
